import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIImage from 'UIComponents/image/UIImage';
import styled from 'styled-components';
import { CALYPSO, LORAX, OBSIDIAN, PANTERA } from 'HubStyleTokens/colors';
import { useState } from 'react';
import ReducedSkeletonThumbnail from './ReducedSkeletonThumbnail';
import { SkeletonWrapper } from '../../../Skeleton';
import Raven from 'raven-js';
import { REDUCED_CARD_THUMBNAIL_SIZES } from '../ReducedCardTypes';
const FLINT_TRANSPARENT_BG = 'rgb(153, 172, 194, 0.75)';
const ThumbnailBox = styled.div.withConfig({
  displayName: "ReducedCardThumbnailSection__ThumbnailBox",
  componentId: "oy99gu-0"
})(["position:relative;min-height:", "px;min-width:", "px;border-radius:3px;overflow:hidden;"], ({
  size
}) => size, ({
  size
}) => size);
const DarkOverlay = styled.div.withConfig({
  displayName: "ReducedCardThumbnailSection__DarkOverlay",
  componentId: "oy99gu-1"
})(["background-color:rgba(0,0,0,0.5);position:absolute;top:0;left:0;bottom:0;right:0;"]);
const GhostOverlay = styled.div.withConfig({
  displayName: "ReducedCardThumbnailSection__GhostOverlay",
  componentId: "oy99gu-2"
})(["background:", ";position:absolute;top:0;left:0;bottom:0;right:0;"], FLINT_TRANSPARENT_BG);
const ProgressBar = styled.div.withConfig({
  displayName: "ReducedCardThumbnailSection__ProgressBar",
  componentId: "oy99gu-3"
})(["position:absolute;bottom:0;left:0;height:4px;width:", ";background-color:", ";"], props => `${props.progressamount * 100}%`, props => props.progressamount === 1 ? CALYPSO : LORAX);
const ThumbnailUIImage = styled(UIImage).withConfig({
  displayName: "ReducedCardThumbnailSection__ThumbnailUIImage",
  componentId: "oy99gu-4"
})(["display:", " !important;height:", "px !important;object-fit:cover;"], props => props.loaded ? 'block' : 'none', ({
  size
}) => size);

const ReducedCardThumbnailSection = ({
  altText,
  deprecated,
  thumbnailUrl,
  progressAmount,
  isCompleted,
  use = 'on-light',
  size = 'medium',
  customAction
}) => {
  const [isImageLoaded, setIsImageLoaded] = useState(!thumbnailUrl);
  const thumbnailSize = REDUCED_CARD_THUMBNAIL_SIZES[size];
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(ThumbnailBox, {
      size: thumbnailSize,
      children: [/*#__PURE__*/_jsx(SkeletonWrapper, {
        shimmercolor: use === 'on-dark' ? OBSIDIAN : undefined,
        style: {
          height: thumbnailSize,
          width: thumbnailSize,
          borderRadius: 3,
          display: isImageLoaded ? 'none' : 'block'
        },
        children: /*#__PURE__*/_jsx(ReducedSkeletonThumbnail, {
          backgroundColor: use === 'on-dark' ? PANTERA : undefined,
          size: size
        })
      }), thumbnailUrl ? /*#__PURE__*/_jsx(ThumbnailUIImage, {
        alt: altText,
        height: thumbnailSize,
        loaded: isImageLoaded ? 1 : 0,
        onError: () => Raven.captureMessage('Reduced card thumbnail failed to load', {
          extra: {
            thumbnailUrl
          }
        }),
        onLoad: () => setIsImageLoaded(true),
        size: thumbnailSize,
        src: thumbnailUrl,
        width: thumbnailSize
      }) : /*#__PURE__*/_jsx(ReducedSkeletonThumbnail, {
        backgroundColor: use === 'on-dark' ? PANTERA : undefined,
        size: size,
        style: {
          display: 'block'
        }
      }), deprecated ? /*#__PURE__*/_jsx(GhostOverlay, {}) : isCompleted ? /*#__PURE__*/_jsx(DarkOverlay, {}) : null, customAction, !deprecated && /*#__PURE__*/_jsx(ProgressBar, {
        progressamount: progressAmount || 0
      })]
    })
  });
};

export default ReducedCardThumbnailSection;